export default __webpack_public_path__ + "static/media/wordsearch_locked.28d01272.svg";